import React, { useState, useEffect } from 'react';

// Yerel veri
const initData = {
    heading: "Socia'ya Nasıl Katılabilirsin?",
    headingText: "Şehrin sosyal rehberine katılmak çok kolay! Sadece üç basit adımda Socia deneyimini yaşamaya başlayabilirsin."
};

// Yerel çalışma verileri
const workData = [
    {
        id: 1,
        image: "/img/work_thumb_1.png",
        title: "Uygulamayı İndir",
        content: "Socia uygulamasını App Store veya Google Play Store'dan ücretsiz olarak indir. Hızlı indirme ve kurulum süreci ile sadece birkaç dakikada kullanıma başlayabilirsin."
    },
    {
        id: 2,
        image: "/img/work_thumb_2.png",
        title: "Profilini Oluştur",
        content: "İlgi alanlarını, tercih ettiğin etkinlik türlerini ve konumunu belirleyerek profilini kişiselleştir. Bu bilgiler sayesinde Socia sana en uygun etkinlik önerilerini sunacak."
    },
    {
        id: 3,
        image: "/img/work_thumb_3.png",
        title: "Etkinliklerin Keyfini Çıkar",
        content: "Artık şehirdeki etkinlikleri keşfetmeye hazırsın! Favori organizatörleri takip et, etkinlikleri filtreleme seçenekleriyle ara ve uygulamanın tüm özelliklerinin keyfini çıkar."
    }
];

const Work = () => {
    const [data, setData] = useState({});
    const [works, setWorks] = useState([]);

    useEffect(() => {
        // API yerine yerel sabitlerden veri ayarlama
        setData(initData);
        setWorks(workData);
    }, []);

    return (
        <section 
            className="section work-area overflow-hidden ptb_100"
            style={{ 
                background: 'radial-gradient(circle, #2F2D51 0%, #1A1E28 100%)',
                color: 'white'
            }}
        >
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-md-10 col-lg-8">
                        {/* Work Content */}
                        <div className="work-content text-center">
                            <h2 className="text-white">{data.heading}</h2>
                            <p className="text-white my-3 mt-sm-4 mb-sm-5">{data.headingText}</p>
                        </div>
                    </div>
                </div>
                <div className="row">
                    {works.map((item, idx) => (
                        <div key={`w_${idx}`} className="col-12 col-md-4">
                            {/* Single Work */}
                            <div className="single-work text-center p-3">
                                {/* Work Icon */}
                                <div className="work-icon">
                                    <img className="avatar-md" src={item.image} alt="" />
                                </div>
                                <h3 className="text-white py-3">{item.title}</h3>
                                <p className="text-white">{item.content}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Work;